export const generateMainPageMarkup = (url: string) => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Интернет-магазин билайн',
  url,
});
